<template>
  <div class="login-shell">
    <section class="login-introduction">
      <button type="button" class="login-brand" @click="home">
        <span class="login-brand__mark"><v-icon color="white">school</v-icon></span>
        <span class="login-brand__name">taleem<span>.app</span></span>
      </button>
      <div class="login-introduction__content">
        <div class="login-eyebrow">Masjid administration</div>
        <h1>Everything your learning community needs.</h1>
        <p>
          Manage students, classrooms, teachers, payments, and report cards
          from one organized workspace.
        </p>
        <div class="login-feature">
          <v-icon>check_circle</v-icon>
          <span>Simple, secure, and built for your community</span>
        </div>
      </div>
    </section>

    <v-card class="login-card" elevation="0">
      <div class="login-card__heading">
        <div class="login-card__icon"><v-icon>lock_open</v-icon></div>
        <div>
          <div class="login-eyebrow">Welcome back</div>
          <h2>Sign in to your account</h2>
          <p>Enter your organization and account details below.</p>
        </div>
      </div>

      <v-card-text class="login-card__body">
        <v-text-field
          ref="locationCode"
          v-model.trim="code"
          :error-messages="codeErrors"
          label="Organization code"
          prepend-inner-icon="business"
          outlined
          hide-details="auto"
          class="login-field"
          @blur="$v.code.$touch()"
        ></v-text-field>

        <v-text-field
          v-model.trim="email"
          :error-messages="emailErrors"
          label="Email address"
          prepend-inner-icon="email"
          outlined
          hide-details="auto"
          class="login-field"
          @blur="$v.email.$touch()"
        ></v-text-field>

        <v-text-field
          v-model="password"
          :append-icon="showPassword ? 'visibility_off' : 'visibility'"
          :type="showPassword ? 'text' : 'password'"
          :label="$t('labels.password')"
          :error-messages="passwordErrors"
          prepend-inner-icon="lock"
          outlined
          hide-details="auto"
          class="login-field"
          @keyup.enter="submit"
          @input="$v.password.$touch()"
          @click:append="showPassword = !showPassword"
        ></v-text-field>

        <div class="login-card__help">
          <button type="button" @click="$router.push({ path: '/forgot' })">
            Forgot password?
          </button>
        </div>

        <v-btn
          :loading="loading"
          class="login-submit"
          color="primary"
          depressed
          block
          large
          @click="submit"
        >
          {{ $t("buttons.login") }}
          <v-icon right>arrow_forward</v-icon>
        </v-btn>
      </v-card-text>

      <div class="login-card__signup">
        <span>New to taleem?</span>
        <button type="button" @click="$router.push({ path: '/signup' })">
          Create an account
        </button>
      </div>
    </v-card>
  </div>
</template>


<script>
import { mapActions } from "vuex";
import authService from "../service";
// import GoogleLogin from "./GoogleLogin";

const { validationMixin } = require("vuelidate");
const { required, email } = require("vuelidate/lib/validators");

export default {
  name: "authentication-login",
  data() {
    return {
      showPassword: false,
      email: null,
      loading: false,
      password: null,
      code: null,
    };
  },
  created() {
    const localStoreCode = localStorage.getItem(
      `${process.env.VUE_APP_STORAGE_PREFIX}code`
    );
    if (localStoreCode) {
      this.code = localStoreCode;
    }
    // console.log("created in login", this.code);
  },
  methods: {
    ...mapActions("global", ["initBusiness", "initUser"]),
    submitLocation() {
      console.log("submitLocation", this.code);
    },
    home() {
      window.open("https://taleem.com", "_self");
    },
    // checkResponse(response) {
    //   if (response.status === 400) {
    //     this.$swal
    //       .mixin({
    //         toast: true,
    //         position: "top-end",
    //         showConfirmButton: false,
    //         timer: 3000,
    //       })
    //       .fire({
    //         icon: "error",
    //         title: "Invalid User",
    //       });
    //   } else {
    //     // this.initUser()
    //     localStorage.setItem(
    //       `${process.env.VUE_APP_STORAGE_PREFIX}code`,
    //       this.code
    //     );
    //     // console.log('tesetd', response.user)
    //     if (response.user.userType === 'teacher') {
    //       this.$router.push({ name: "thome" });
    //       // return false
    //     }
    //     else {
    //       this.$router.push({ name: "home" });
    //       // return false
    //     }

    //   }
    // },
    checkResponse(response) {
      if (response.status === 400) {
        this.$swal
          .mixin({
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
          })
          .fire({
            icon: "error",
            title: "Invalid User",
          });
        return;
      }

      // Save code
      localStorage.setItem(
        `${process.env.VUE_APP_STORAGE_PREFIX}code`,
        this.code
      );

      // If teacher, block app login and redirect them to teacher portal
      if (response?.user?.userType === "teacher") {
        this.$swal
          .fire({
            icon: "info",
            title: "Teacher account",
            html: `Teachers now sign in at <b>teacher.taleem.app</b>.<br/>Click Continue to go there.`,
            confirmButtonText: "Continue",
            showCancelButton: true,
            cancelButtonText: "Cancel",
            allowOutsideClick: false,
          })
          .then((result) => {
            const confirmed =
              result === true ||
              result?.isConfirmed === true ||
              result?.value === true;

            if (confirmed) {
              // replace is a bit cleaner than href (no back button to this page)
              window.location.replace("https://teacher.taleem.app");
            }
          });

        return;
      }

      // Normal users
      this.$router.push({ name: "home" });
    },
    submit() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.$swal
          .mixin({
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
          })
          .fire({
            icon: "error",
            title: this.$t("toastMessage.text.invalidFields"),
          });
      } else {
        this.loading = true;
        this.$Progress.start();
        authService
          .authenticate({
            email: this.email,
            password: this.password,
            code: this.code,
          })
          .then((response) => {
            this.$Progress.finish();
            // console.log('response after login', response)
            this.checkResponse(response);
            this.loading = false;
          })
          .catch((error) => {
            this.$Progress.finish();
            this.loading = false;
            console.log("error on ", error);
            const message =
              (error && error.data && error.data.message) ||
              (error && error.message) ||
              "Unable to reach the Taleem server. Please confirm the backend is running.";
            this.$swal("Login Failed", message, "error");
          });
      }
    },
  },
  computed: {
    codeErrors() {
      const errors = [];
      if (!this.$v.code.$dirty) return errors;
      if (!this.$v.code.required) errors.push("Code is required.");
      return errors;
    },
    emailErrors() {
      const errors = [];
      if (!this.$v.email.$dirty) return errors;
      if (!this.$v.email.email) errors.push("Email is not valid");
      if (!this.$v.email.required) errors.push("Email is required.");
      return errors;
    },
    passwordErrors() {
      const errors = [];
      if (!this.$v.password.$dirty) return errors;
      if (!this.$v.password.required) errors.push("Password is required.");
      return errors;
    },
  },
  mixins: [validationMixin],
  validations: {
    email: {
      email,
      required,
    },
    code: {
      required,
    },
    password: {
      required,
    },
  },
};
</script>

<style scoped>
.login-shell {
  position: relative;
  z-index: 1;
  display: grid;
  width: min(1040px, 100%);
  grid-template-columns: minmax(0, 1fr) minmax(380px, 460px);
  overflow: hidden;
  border: 1px solid #dfe7e0;
  border-radius: 22px;
  background: #fff;
  box-shadow: 0 24px 70px rgba(32, 61, 37, 0.13);
}

.login-introduction {
  display: flex;
  min-height: 610px;
  padding: 42px 48px;
  flex-direction: column;
  color: #fff;
  background: linear-gradient(145deg, #2f8f3a 0%, #43a047 58%, #66b96d 100%);
}

.login-brand {
  display: inline-flex;
  align-self: flex-start;
  align-items: center;
  border: 0;
  color: inherit;
  background: transparent;
  cursor: pointer;
}

.login-brand__mark {
  display: inline-flex;
  width: 46px;
  height: 46px;
  margin-right: 13px;
  align-items: center;
  justify-content: center;
  border: 1px solid rgba(255, 255, 255, 0.35);
  border-radius: 13px;
  background: rgba(255, 255, 255, 0.15);
}

.login-brand__name {
  font-size: 27px;
  font-weight: 800;
  letter-spacing: -0.04em;
}

.login-brand__name span {
  font-weight: 500;
  opacity: 0.82;
}

.login-introduction__content {
  margin: auto 0;
}

.login-eyebrow {
  margin-bottom: 8px;
  color: #43a047;
  font-size: 11px;
  font-weight: 800;
  letter-spacing: 0.12em;
  text-transform: uppercase;
}

.login-introduction .login-eyebrow {
  color: rgba(255, 255, 255, 0.76);
}

.login-introduction h1 {
  max-width: 440px;
  margin: 0 0 20px;
  font-size: clamp(34px, 4vw, 49px);
  line-height: 1.08;
  letter-spacing: -0.035em;
}

.login-introduction p {
  max-width: 450px;
  margin: 0;
  color: rgba(255, 255, 255, 0.82);
  font-size: 16px;
  line-height: 1.7;
}

.login-feature {
  display: flex;
  margin-top: 32px;
  align-items: center;
  color: rgba(255, 255, 255, 0.92);
  font-size: 13px;
  font-weight: 600;
}

.login-feature .v-icon {
  margin-right: 9px;
  color: #fff;
  font-size: 20px;
}

.login-card {
  display: flex;
  min-width: 0;
  padding: 52px 44px 0;
  flex-direction: column;
  border-radius: 0 !important;
}

.login-card__heading {
  display: flex;
  align-items: flex-start;
}

.login-card__icon {
  display: flex;
  width: 48px;
  height: 48px;
  margin-right: 15px;
  flex: 0 0 48px;
  align-items: center;
  justify-content: center;
  border-radius: 14px;
  background: #eaf6eb;
}

.login-card__icon .v-icon {
  color: #43a047;
}

.login-card h2 {
  margin: 0;
  color: #172033;
  font-size: 25px;
  line-height: 1.25;
  letter-spacing: -0.025em;
}

.login-card__heading p {
  margin: 7px 0 0;
  color: #778396;
  font-size: 13px;
  line-height: 1.5;
}

.login-card__body {
  padding: 34px 0 28px !important;
}

.login-field {
  margin-bottom: 18px;
}

.login-field::v-deep .v-input__slot {
  min-height: 56px;
  border-radius: 12px;
  background: #fbfcfb;
}

.login-field::v-deep .v-input__prepend-inner .v-icon,
.login-field::v-deep .v-input__append-inner .v-icon {
  color: #7b887e;
}

.login-field::v-deep.v-input--is-focused .v-input__slot {
  background: #fff;
}

.login-card__help {
  margin: -3px 0 22px;
  text-align: right;
}

.login-card__help button,
.login-card__signup button {
  border: 0;
  color: #388e3c;
  font-size: 13px;
  font-weight: 700;
  background: transparent;
  cursor: pointer;
}

.login-card__help button:hover,
.login-card__signup button:hover {
  text-decoration: underline;
}

.login-submit {
  height: 52px !important;
  border-radius: 12px;
  font-weight: 700;
  letter-spacing: 0.01em;
  text-transform: none;
}

.login-card__signup {
  margin: auto -44px 0;
  padding: 21px 24px;
  border-top: 1px solid #e7ece8;
  color: #7b867e;
  text-align: center;
  font-size: 13px;
  background: #fbfcfb;
}

.login-card__signup button {
  margin-left: 4px;
}

@media (max-width: 840px) {
  .login-shell {
    max-width: 480px;
    grid-template-columns: 1fr;
  }

  .login-introduction {
    min-height: auto;
    padding: 25px 30px;
  }

  .login-introduction__content {
    display: none;
  }

  .login-card {
    min-height: 540px;
    padding: 38px 34px 0;
  }

  .login-card__signup {
    margin-right: -34px;
    margin-left: -34px;
  }
}

@media (max-width: 480px) {
  .login-shell {
    border-radius: 17px;
  }

  .login-introduction {
    padding: 19px 22px;
  }

  .login-brand__mark {
    width: 40px;
    height: 40px;
  }

  .login-brand__name {
    font-size: 23px;
  }

  .login-card {
    min-height: 525px;
    padding: 30px 22px 0;
  }

  .login-card__icon {
    display: none;
  }

  .login-card__signup {
    margin-right: -22px;
    margin-left: -22px;
  }
}
</style>
